<template>
  <div class="range-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-end">
        <el-button @click="submitRange" type="primary">提交范围</el-button>
      </div>
      <div v-for="(building,bnum) in buildingList" :key="building.id">
        <div class="font-size flex align-center justify-between building-name ">
          <h3 class="flex align-center">{{ building.building_name }} 分布图 <span>（{{ building.element_list.length }}个单元）</span>
            <el-button size="mini" round type="primary" @click="chioseBuilding(bnum)">全选/取消</el-button>
          </h3>

        </div>
        <div class="w-100 padding-tb-xs" v-for="(item,elnum) in building.element_list" :key="item.id">
          <div class="unit-scroll flex align-start flex-wrap">
            <div class="  unit-box"
                 :style="{width:(item.chuan_index*150+1) + 'px'} ">
              <div class="flex align-center">
                <div v-for="(chuan,cindex) in item.chuan_index" :key="cindex" class="unit-item active"
                     style="width: 150px">
                  {{ chuan }}串
                </div>
              </div>
              <div class="flex align-center flex-wrap">
                <div v-for="room in item.room_list" :key="room.id">

                  <div  class="unit-item active2" style="width: 150px" v-if="room.juzhu_qingkuang === 3">
                    <p>{{ building.building_name + '-' + item.element_name + '-' + room.room_name }}</p>
                  </div>
                  <div  class="unit-item" :class="{'check':room.state}" style="width: 150px" v-else @click="room.state = !room.state">
                    <p>{{ building.building_name + '-' + item.element_name + '-' + room.room_name }}</p>
                  </div>
                </div>

              </div>
              <div class="unit-name">

                <span>{{ item.element_name }}</span> <el-button size="mini" round type="primary" @click="chioseEl(bnum,elnum)">全选/取消</el-button></div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import {duLiMinDiaoFanWeiAdd, duLiMinDiaoFanWeiShow, minDiaoFanWeiLouMenHuList} from "@/api/merdeka";

export default {
  name: "merdeka-center-range",
  data() {
    return {
      buildingList: [],
      chioseRoom:[]
    }
  },
  created() {
    this.$emit("setIndex", '/home/merdeka-center', "独立民调 / 民调范围", true);
    this.minDiaoFanWeiLouMenHuList()

  },
  components: {},
  methods: {
    //  提交选择的范围
    submitRange(){
      let _arr = []
      this.buildingList.map(item=>{
        item.element_list.map(items=>{
          items.room_list.map(room=>{
            if(room.state) {
              _arr.push({
                lou:item.id,
                men:items.id,
                hu:room.id
              })
            }
          })
        })
      })
      if(_arr.length === 0) return this.$message.error('请选择民调范围')
      this.sureSub(_arr)
    },
    async sureSub(room){
      let _state = await duLiMinDiaoFanWeiAdd(
          this.$route.params.id,
          this.$route.query.pid,
          this.$route.params.cid,
          JSON.stringify(room)
      )
      this.$message.success(_state.info)
      this.$router.go(-1)
    },
    //  获取小区楼栋
    async minDiaoFanWeiLouMenHuList() {
      let _list = await minDiaoFanWeiLouMenHuList(this.$route.params.cid)
      _list.data.map(item=>{
        item.buildingState = false
        item.element_list.map(items=>{
          items.room_list.map(room=>{
            room.state = false
          })
        })
      })
      this.buildingList = _list.data
      this.duLiMinDiaoFanWeiShow()
    },
    //  获取选择的房间
    async duLiMinDiaoFanWeiShow(){
      let _data = await duLiMinDiaoFanWeiShow(this.$route.params.id)
      this.chioseRoom = _data.data.split(',').map(Number)
      this.buildingList.map(item=>{
        item.element_list.map(items=>{
          items.room_list.map(room=>{
            if(this.chioseRoom.indexOf(room.id)!==-1){
              room.state = true
            }
          })
        })
      })
    },
    chioseBuilding(num){
      this.buildingList[num].buildingState = !this.buildingList[num].buildingState
      this.buildingList[num].element_list.map(item=>{
        item.room_list.map(items=>{
          items.state = this.buildingList[num].buildingState
        })
      })
    },
    chioseEl(num,elnum){
      this.buildingList[num].element_list[elnum].room_list.map(item=>{
        item.state = !item.state
      })
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.range-warpper {
  .building-name {
    cursor: pointer;
    padding: 10px;

    span {
      font-weight: normal;
      color: #999;
      font-size: 14px;
    }

    p {
      color: #d00000;
      font-weight: normal;
      font-size: 14px;
    }
  }

  .unit-scroll {
    width: 100%;
    overflow: auto;

    .unit-box {
      border-top: 1px solid #eee;
      border-left: 1px solid #eee;
      box-sizing: border-box;

      .unit-item {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 150px;
        height: 50px;
        padding: 0 10px;
        box-sizing: border-box;
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;
        cursor: pointer;

        &.active {
          background: #eee;
          justify-content: center;
        }
        &.active2 {
          background: #ccc;
          justify-content: center;
        }
        &.check{
          background: rgba(213, 0, 0, 0.45);
          color: #fff;
          justify-content: center;
        }
        p {
          flex: 1;
          text-align: center;
        }

        i {
          display: block;
          width: 10px;
          height: 10px;
          border-radius: 10px;

          &.active1 {
            background-color: #1bb2cd;
          }

          &.active2 {
            background-color: #bf984c;
          }

          &.active3 {
            background-color: #be3600;
          }
        }
      }

      .unit-name {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 50px;
        color: #d00000;
        border: 1px solid #eeee;
        border-top: 0;
        font-weight: bold;
        span{
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
